define('modules/editor/views/elements/image',['require','exports','module','./element','../../services/image_upload/index','ldsh!../../templates/elements/image'],function(require, exports, module){
  "use strict";
  var Element = require("./element"),
      ImageUploadService = require("../../services/image_upload/index");

  module.exports = Element.extend({
    className: "ed-panel-item ed-item-image editor-item-image",
    template: require("ldsh!../../templates/elements/image"),
    initialize: function() {
      module.exports.__super__.initialize.apply(this, arguments);
      this.listenTo(this.model, "image:upload:start", this._onUploadStart);
    },
    _onUploadStart: function() {
      this.$(".js-spinner").show();
    },
    onEditContent: function(){
      //edit image
      ImageUploadService.loadImage(
        this.model.get("imageUrl"),
        _.bind(function(results){
          this.model.getPropertyGroup("image:content").set(
            {
              "imageUrl": results.url,
              "imageId": results.id
            });
          this.model.getPropertyGroup("image:content").getImageSize();
        }, this));
    },
    onRender: function() {
      this.$(".js-spinner").hide();
      this.$el.i18n();
    }
  });
});

